module.exports = __webpack_public_path__ + "img/jo.2c18a320.jpeg";